import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 2797C36A-5A29-4679-AAB7-4F4832FA7DC5
 * name view-quilt-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-quilt-outline.svg
 * tags
 * - View 
 */
export const ViewQuiltOutlineIcon = createSvgIcon(<><path d="M4 5V18H21V5H4M6 16V7H9V16H6M11 16V12.5H14V16H11M19 16H16V12.5H19V16M11 10.5V7H19V10.5H11Z" /></>, 'ViewQuiltOutlineIcon');
export default ViewQuiltOutlineIcon